import { useState, useEffect } from "react";
import "./FormContentSection.css";
import { Question, UpdateQuestionPayload } from "effno-core";
import { apiUpdateQuestion } from "../../services/QuestionService";
import { toastFail, toastSuccess } from "../../config";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { selectEditingForm, selectUIStates, selectViewingFormThemeSettings, setEditingForm } from "../../redux/features/appData";
import { useDispatch } from "react-redux";
import { SECTION_SETTINGS } from "../config/questionSettings";
import { DEBOUNCE_TIME } from "../config/forms";
import { apiFormHasEdits } from "../../services/FormService";

const DEFAULT_FONT_SIZE = 16;
const INPUT_PADDING = 0;
const INPUT_BORDER_WIDTH = 0;

type FormContentSectionProps = {
    question: Question;
    allowSaving?: boolean;
}

export const FormContentSection = ({question, allowSaving = true} : FormContentSectionProps) => {

    const dispatch = useDispatch();

    const editingForm = useSelector(selectEditingForm);
    const viewingFormThemeSettings = useSelector(selectViewingFormThemeSettings)

    const [title, setTitle] = useState<string>("Section Name");
    const [style, setStyle] = useState<any>(undefined);
    const [fontSize, setFontSize] = useState<number | undefined>(undefined);

    const [debouncedData, setDebouncedData] = useState<any | undefined>(undefined);
    const [debounceSettings, setDebounceSettings] = useState<any | undefined>(undefined);

    useEffect(() => {
        if (question.settings) {
            setTitle(question.title);

            const settings = JSON.parse(question.settings);

            let fs = settings.fontSize || 16;
            setFontSize(settings.fontSize);
            // setStyle({width: question.title.length + 2 + "ch", fontSize: fs + "px"});
        } else {
            setFontSize(DEFAULT_FONT_SIZE);
        }
    }, [question]);

    useEffect(() => {

        let font = viewingFormThemeSettings?.font || "--default-ftFont";

        if (fontSize && font) {
            // Create a temporary element to measure character width
            const span = document.createElement('span');
            span.style.fontSize = `${fontSize}px`;
            span.style.fontFamily = font;
            // span.style.position = 'absolute';
            span.innerText = title;
            span.style.whiteSpace = "pre";
            span.style.visibility = "hidden"
            // span.value = title; // write the whole title to get the width
            document.body.appendChild(span);
            
            // Get the width of the span
            const titleWidth = span.offsetWidth + 50;
            document.body.removeChild(span);
            
            // Calculate total width
            
                // const width = charWidth * title.length + 
                // INPUT_PADDING * 2 + INPUT_BORDER_WIDTH * 2;
            setStyle({
                // width: title.length + "ch",
                width: titleWidth + "px",
                maxWidth: "100%",
                fontSize: fontSize + "px",
                // border: "1px solid green"
            });
        } 
          
    }, [fontSize, title, viewingFormThemeSettings]);

    // Debounce settings changes
    useEffect(() => {
        const handler = setTimeout(() => {
            if (!debounceSettings) {
                return;
            }
            setDebouncedData(debounceSettings);
        }, DEBOUNCE_TIME);

        // Clear the timeout if settings changes (i.e., user is still typing)
        return () => {
            clearTimeout(handler);
        };
    }, [debounceSettings]);

    // Effect to save the debounced data whenever it changes
    useEffect(() => {
        (async () => {
            if (!debouncedData) {
                return;
            }

            console.log("debouncedData: ", debouncedData);
            
            await handleSave();
        })()
    }, [debouncedData]);

    useEffect(() => {
        setDebounceSettings({
            title,
        })
    }, [title])

    const updateRedux = () => {
        if (!editingForm) {
            return;
        }

        const index = editingForm.questions.findIndex((q: Question) =>  q.id === question.id);

        if (index === -1) {
            toast("Can't find question id", toastFail);
            return;
        }

        const newQuestions = [...editingForm.questions];
        newQuestions[index] = {
            ...question,
            title,
        };

        dispatch(setEditingForm({...editingForm, hasEdits: true, questions: newQuestions}));
    }

    const handleSave = async () => {
        if (!editingForm || !allowSaving) {
            return;
        }

        // update question in redux first to avoid delay lag causing issues
        updateRedux();

        const settings = question.settings ? JSON.parse(question.settings) : SECTION_SETTINGS;

        const payload : UpdateQuestionPayload = {
            questionId: question.id,
            type: question.type,
            title: title,
            description: "",
            required: question.required,
            settings: JSON.stringify(settings),  // these don't change in this instance
            conditions: question.conditions
        }

        const newQuestion = await apiUpdateQuestion(payload);

        if (!newQuestion) {
            toast("Error saving update", toastFail);
            return;
        }

        await apiFormHasEdits(editingForm.id);
        console.log("Question updated");

        // update redux
        // const index = editingForm.questions.findIndex((q: Question) =>  q.id === question.id);

        // if (index === -1) {
        //     toast("Can't find question id", toastFail);
        //     return;
        // }

        // const newQuestions = [...editingForm.questions];
        // newQuestions[index] = newQuestion;

        // await apiFormHasEdits(editingForm.id);

        // dispatch(setEditingForm({...editingForm, hasEdits: true, questions: newQuestions}));

        // console.log("Question updated");

    }

    console.log("[FormContentSection] question: ", question);
    console.log("[FormContentSection] title: ", title);


    return (
        <div className="form-content-body">
            <div className="form-content-section">
                {style && 
                    <input 
                        type="text"
                        placeholder=""
                        value={title}
                        style={style} 
                        // onInput={(e) => 
                        //     setStyle({width: e.target.value.length + 1 + "ch"})
                        // }
                        onChange={(e) => {
                            // setStyle({
                            //     width: e.target.value.length + 2 + "ch",
                            //     fontSize: fontSize + "px"
                            // })
                            setTitle(e.target.value)
                        }}
                        maxLength={50}
                        data-testid="question-title"
                    />
                }
            </div>     
                     
            {/* <button 
                onClick={handleSave}
                data-testid="save-question"
            >
                temp save button before debounce 
            </button> */}
        </div>
    )
}